"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsivePopoverAndBottomSheetToggler = void 0;
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const bottom_sheet_1 = require("../bottom-sheet");
const page_wrapper_1 = require("../page-wrapper");
const popover_1 = require("../popover");
const styles_1 = require("./styles");
const ResponsivePopoverAndBottomSheetToggler = (props) => {
    const deviceView = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    switch (deviceView) {
        case monera_app_core_1.DeviceType.MShop:
        case monera_app_core_1.DeviceType.Mobile:
            return react_1.default.createElement(Mobile, Object.assign({}, props));
        case monera_app_core_1.DeviceType.Desktop:
        case monera_app_core_1.DeviceType.Tablet:
        default:
            return react_1.default.createElement(Desktop, Object.assign({}, props));
    }
};
exports.ResponsivePopoverAndBottomSheetToggler = ResponsivePopoverAndBottomSheetToggler;
const Common = (props) => {
    const { onClick, onMouseEnter, onMouseLeave, children, primaryContent, dataCy, primaryContentRef } = props;
    return primaryContent ? (react_1.default.createElement(styles_1.PrimaryContentContainer, { "data-cy": dataCy, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        react_1.default.createElement("div", { ref: primaryContentRef, onClick: onClick }, primaryContent),
        children)) : null;
};
const Desktop = (props) => {
    var _a, _b;
    const [isOpen, setShowPopOver] = (0, react_1.useState)(false);
    const primaryContentRef = (0, react_1.useRef)(null);
    const handleMouseLeave = (0, debounce_1.default)(() => {
        setShowPopOver(false);
    }, 500);
    const handleMouseEnter = () => {
        handleMouseLeave.cancel();
        setShowPopOver(true);
    };
    return (react_1.default.createElement(Common, Object.assign({}, props, { primaryContentRef: primaryContentRef, onMouseLeave: handleMouseLeave, onMouseEnter: handleMouseEnter }),
        react_1.default.createElement(styles_1.PopOverContainer, { isOpen: isOpen },
            react_1.default.createElement(popover_1.Popover, { bubbleNotchHorizontalPosition: ((_a = primaryContentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth)
                    ? Math.floor(((_b = primaryContentRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) / 2).toString()
                    : '1', headerText: props.headerText, closePopover: () => setShowPopOver(false) }, props.innerContent))));
};
const Mobile = (props) => {
    const [isBottomSheetOpen, setBottomSheetOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(Common, Object.assign({}, props, { onClick: () => setBottomSheetOpen(true) }),
        react_1.default.createElement(bottom_sheet_1.BottomSheet, { isOpen: isBottomSheetOpen, headerText: props.headerText, onClose: () => setBottomSheetOpen(false) }, props.innerContent)));
};
